export default __webpack_public_path__ + "static/media/certificate.5c6e3e66.png";